var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChooseUsTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 41.5,
    stroke: "black",
    strokeDasharray: "4 4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 31,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 57.691V58.9657H27.3448V53.8669H28.5172V58.9657H32.9513L29.5484 48.9664C26.8284 50.7542 25 53.9906 25 57.691Z",
    fill: "#EE2536"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9142 42.3948H29.8444C30.3678 44.6172 32.2115 46.2189 34.3793 46.2189C36.547 46.2189 38.3907 44.6172 38.9142 42.3948Z",
    fill: "#EE2536"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2103 48.9664L35.8074 58.9657H40.2414V53.8669H41.4139V58.9657H43.7587V57.691C43.7587 53.9906 41.9303 50.7542 39.2103 48.9664Z",
    fill: "#EE2536"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5947 48.368L32.2842 53.3316L33.5779 51.925L30.6791 48.3234C30.6498 48.3374 30.6229 48.3546 30.5947 48.368Z",
    fill: "#EE2536"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3793 52.8561L32.7314 54.6477L34.2011 58.9657H34.5575L36.0271 54.6477L34.3793 52.8561Z",
    fill: "#EE2536"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8739 47.874L34.3793 50.9874L36.8848 47.874C36.0858 47.6325 35.2481 47.4935 34.3793 47.4935C33.5106 47.4935 32.6729 47.6325 31.8739 47.874Z",
    fill: "#EE2536"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1639 48.368C38.1352 48.3546 38.1088 48.3374 38.0801 48.324L35.1813 51.9256L36.475 53.3322L38.1639 48.368Z",
    fill: "#EE2536"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6552 30.5843L50.2069 24.7418V30.9227H48.8076L42.5862 24.7736V30.9227H33.2069V32.1974H56.6552V30.5843Z",
    fill: "#EE2536"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9745 22H35.4738L34.469 29.6481H38.9793L37.9745 22Z",
    fill: "#EE2536"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3793 36.0214C32.6921 36.0214 31.161 37.0189 30.3333 38.5708H38.4258C37.5975 37.0189 36.0664 36.0214 34.3793 36.0214Z",
    fill: "#EE2536"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5172 41.1201H40.2414C40.565 41.1201 40.8276 40.8346 40.8276 40.4828C40.8276 40.131 40.565 39.8455 40.2414 39.8455H28.5172C28.1937 39.8455 27.931 40.131 27.931 40.4828C27.931 40.8346 28.1937 41.1201 28.5172 41.1201Z",
    fill: "#EE2536"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2759 36.0214H44.931V38.5708H47.2759V36.0214Z",
    fill: "#EE2536"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2759 39.8455H44.931V42.3948H47.2759V39.8455Z",
    fill: "#EE2536"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3104 47.4935H51.9656V50.0429H54.3104V47.4935Z",
    fill: "#EE2536"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4138 47.4935H55.4828V51.3176H50.7931V47.4935H47.8621C47.5385 47.4935 47.2759 47.7791 47.2759 48.1309V58.3283C47.2759 58.6801 47.5385 58.9656 47.8621 58.9656H58.4138C58.7374 58.9656 59 58.6801 59 58.3283V48.1309C59 47.7791 58.7374 47.4935 58.4138 47.4935ZM53.1379 57.691H51.9655V56.4163H53.1379V57.691ZM55.4828 57.691H54.3104V56.4163H55.4828V57.691ZM57.8276 57.691H56.6552V56.4163H57.8276V57.691ZM57.8276 55.1416H51.9655V53.8669H57.8276V55.1416Z",
    fill: "#EE2536"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6552 46.2188V33.472H33.2069V34.8812C33.5885 34.7958 33.9801 34.7467 34.3793 34.7467C36.7136 34.7467 38.8193 36.2661 39.7449 38.5708H40.2414C41.211 38.5708 42 39.4286 42 40.4828C42 41.5369 41.211 42.3948 40.2414 42.3948H40.1212C39.7771 44.2444 38.7073 45.7772 37.2629 46.665C38.6428 47.0926 39.909 47.8122 40.997 48.7682H46.1035V48.1309C46.1035 47.0767 46.8925 46.2188 47.8621 46.2188H56.6552ZM43.7586 43.6695V34.7467H55.4828V43.6695H43.7586Z",
    fill: "#EE2536"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7931 39.8455H48.4482V42.3948H50.7931V39.8455Z",
    fill: "#EE2536"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3104 36.0214H51.9656V38.5708H54.3104V36.0214Z",
    fill: "#EE2536"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7931 36.0214H48.4482V38.5708H50.7931V36.0214Z",
    fill: "#EE2536"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3104 39.8455H51.9656V42.3948H54.3104V39.8455Z",
    fill: "#EE2536"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseUsTwo);
export default __webpack_public_path__ + "static/media/chooseUsTwo.1dd26f6fa1f44d51e1b3d04a554cb5a7.svg";
export { ForwardRef as ReactComponent };